import { render, staticRenderFns } from "./SupplementaryApproval.vue?vue&type=template&id=44de699a&scoped=true&"
import script from "./SupplementaryApproval.vue?vue&type=script&lang=js&"
export * from "./SupplementaryApproval.vue?vue&type=script&lang=js&"
import style0 from "./SupplementaryApproval.vue?vue&type=style&index=0&id=44de699a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44de699a",
  null
  
)

export default component.exports